import React, { useMemo } from 'react';
import TicketsButtonContainer from '../../../containers/TicketsButtonContainer';
import { ListingListItemImage } from '@showclix-shared/ListingComponents';
import { getXssFilter } from '../../../helpers/helpers';
import TicketsGoOnSale from "../../../../listing/components/TicketsGoOnSale";

export const MultiEmbedItem = ({ listingConfig }) => {
  const { listings, images } = listingConfig;

  const location = useMemo(() => {
    return listings.location;
  }, [listings]);

  const image = useMemo(() => {
    if ('embed_image' in images) {
      return <ListingListItemImage classNamePrefix="embed-" src={images.embed_image} />;
    }

    return (
      <div className="embed-listing-item__image embed-listing-item__image--empty">
        <i className="icon-calendar" aria-hidden="true" />
      </div>
    );
  }, []);

  return (
    <>
      <div className="embed-listing-item__hero">{image}</div>
      <div className="embed-listing-item__content">
        <div>
          <div className="embed-listing-item__header">
            <h3 dangerouslySetInnerHTML={{__html: listings.name}}/>
          </div>
          <div className="embed-listing-item__description">
            <p>{listings.time}</p>
            <p dangerouslySetInnerHTML={{__html: getXssFilter().process(location)}}/>
          </div>
        </div>
        <div className="embed-listing-item__on-sale">
          <TicketsGoOnSale/>
        </div>
        <div className="embed-listing-item__buttons">
          <TicketsButtonContainer/>
        </div>
      </div>
    </>
  );
};
